import React, { createRef, useEffect, useRef } from 'react'

import { withStyles } from '@material-ui/core/styles'

import * as PoziUtils from 'api/utils'
import PoziNotifications from 'utils/notifications'

import GeostylerLegendRenderer from './GeoStylerLegendRenderer'

const styles = theme => ({
  geostyler: {
    fontSize: '1.5em',
    '& svg': {
      height: 'auto' // this prevents big vertical margins in Firefox
    },
    '& .legend-title': {
      fontWeight: 'bold',
      display: props => props.hideTitle ? 'none' : 'inherit'
    }
  }
})

const LegendGeoStyler = withStyles(styles)((props) => {
  const { classes, layerLoadStatus, mapXYZ, titleid, ...userOptions } = props

  const ref = createRef()

  const defaultOptions = {
    hideRect: true,
    maxColumnWidth: 300,
    // maxColumnHeight: 300,
    overflow: 'auto', // 'auto', 'group'
    size: [400, 100], // width, height
    styles: [] // geostyler styles
  }

  const options = {
    ...defaultOptions,
    ...userOptions
  }

  if (!options.styles || options.styles.length === 0) {
    console.log('LegendGeoStyler - No GeoStyler styles provided')

    return null
  }

  // Deconstruct map XYZ array in order to not have an infinite loop calling
  // the useEffect when something goes wrong.
  const [mapX, mapY, mapZ] = mapXYZ

  const renderLegend = async () => {
    // console.debug('GeoStylerLegend - renderLegend', props, userOptions, ref, classes)

    try {
      const geostylerLegend = new GeostylerLegendRenderer(options)
      await geostylerLegend.render(ref.current)
    } catch (error) {
      console.log('GeostylerLegend - Error rendering style', error)

      const layerConf = PoziUtils.getLayerFromTitleID(titleid)
      const layerTitle = layerConf?.title || 'unknown layer'
      PoziNotifications().warning(`Something went wrong: unable to show the legend for layer '${layerTitle}'`)
    }
  }

  useEffect(() => {
    // console.debug('GeoStylerLegend - useEffect', layerLoadStatus, mapX, mapY, mapZ, styles)

    renderLegend()
  }, [layerLoadStatus, mapX, mapY, mapZ, titleid]) // if an empty array [] is provided, it means 'run once'

  return (
    <legend ref={ref} className={classes.geostyler}></legend>
  )
})

export default LegendGeoStyler
